<script>
  import { clickOutside } from '../../utils/clickOutside.js';
  import { createEventDispatcher } from 'svelte';

  export let assignedStaffMembers = [];
  export let availableStaffToAdd = [];
  export let staffLabel = (m) => m?.email || m?.id || 'Staff';
  export let saving = false;

  const dispatch = createEventDispatcher();
  let staffDropdownOpen = false;

  function add(friend) {
    dispatch('add', { id: friend.id });
    staffDropdownOpen = false;
  }

  function remove(member) {
    dispatch('remove', { id: member.id });
  }
</script>

<div class="assign-staff-section" data-testid="assign-staff-section">
  <div class="assign-staff-label">Assign Staff:</div>
  <div class="assign-staff-row">
    {#each assignedStaffMembers as member (member.id)}
      <div
        class="assign-staff-pill"
        class:assign-staff-pill--external={member.external || member.isTeamMember === false}
        data-testid="assign-staff-pill"
        title={member.email || member.name}
      >
        <span class="assign-staff-pill-text">{staffLabel(member)}</span>
        {#if member.external || member.isTeamMember === false}
          <span class="assign-staff-pill-badge" title="Listed on FluentCase/MerusCase but not on your LegalPal team">
            Non-team
          </span>
        {/if}
        <button
          type="button"
          class="assign-staff-pill-remove"
          data-testid="assign-staff-pill-remove"
          aria-label="Remove {member.email || member.name}"
          disabled={saving}
          on:click={() => remove(member)}
        >×</button>
      </div>
    {/each}

    <div class="assign-staff-add-wrap">
      <button
        type="button"
        class="assign-staff-add-btn"
        data-testid="assign-staff-add-btn"
        disabled={saving}
        on:click={() => (staffDropdownOpen = !staffDropdownOpen)}
      >
        Add Staff
        <span class="assign-staff-add-chevron">▾</span>
      </button>
      {#if staffDropdownOpen}
        <div
          class="assign-staff-dropdown"
          data-testid="assign-staff-dropdown"
          use:clickOutside
          on:click_outside={() => (staffDropdownOpen = false)}
        >
          {#each availableStaffToAdd as friend (friend.id)}
            <button
              type="button"
              class="assign-staff-option"
              data-testid="assign-staff-option"
              on:click={() => add(friend)}
            >
              {friend.email || friend.name || friend.id}
            </button>
          {/each}
          {#if availableStaffToAdd.length === 0}
            <div class="assign-staff-empty">
              {assignedStaffMembers.length === 0
                ? 'No team members available'
                : 'All team members assigned'}
            </div>
          {/if}
        </div>
      {/if}
    </div>
  </div>
</div>

<style>
  .assign-staff-section {
    margin: 6px 0 10px;
    padding: 0 8px;
  }

  .assign-staff-label {
    font-weight: 700;
    font-size: 14px;
    color: #111827;
    padding: 4px 0 2px;
  }

  .assign-staff-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
  }

  .assign-staff-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 220px;
    padding: 4px 8px;
    background: #e5e7eb;
    border-radius: 999px;
    font-size: 12px;
    color: #374151;
  }

  .assign-staff-pill--external {
    background: #fff7ed;
    border: 1px solid #fdba74;
    color: #9a3412;
  }

  .assign-staff-pill-badge {
    flex-shrink: 0;
    padding: 1px 6px;
    border-radius: 999px;
    background: #ea580c;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .assign-staff-pill-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .assign-staff-pill-remove {
    border: none;
    background: transparent;
    color: #6b7280;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    padding: 0;
  }

  .assign-staff-pill-remove:hover:not(:disabled) {
    color: #111827;
  }

  .assign-staff-pill-remove:disabled,
  .assign-staff-add-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .assign-staff-add-wrap {
    position: relative;
  }

  .assign-staff-add-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #fff;
    color: #374151;
    font-size: 13px;
    cursor: pointer;
  }

  .assign-staff-add-btn:hover:not(:disabled) {
    border-color: #9ca3af;
    background: #f9fafb;
  }

  .assign-staff-add-chevron {
    font-size: 11px;
    color: #6b7280;
  }

  .assign-staff-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    min-width: 220px;
    max-height: 200px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    z-index: 1100;
  }

  .assign-staff-option {
    display: block;
    width: 100%;
    text-align: left;
    border: none;
    background: transparent;
    padding: 8px 12px;
    font-size: 13px;
    color: #374151;
    cursor: pointer;
  }

  .assign-staff-option:hover {
    background: #f3f4f6;
  }

  .assign-staff-empty {
    padding: 10px 12px;
    font-size: 13px;
    color: #9ca3af;
  }
</style>
